/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".buttonModal[_ngcontent-%COMP%]{width:100%}.footerActionSize[_ngcontent-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto}.login-footer[_ngcontent-%COMP%]{text-align:center;padding-top:20px;padding-bottom:20px}"];
export { styles as styles };
